const API_URL = "https://api.techpression.com";
// const API_URL = "http://localhost:4000/api/v1";
export const imageUrl = `${API_URL}/static`;

const fetchOrThrowError = async (url, message) => {
  try {
    const response = await fetch(`${API_URL}/${url}`);
    if (!response.ok) {
      throw new Error(`${message}: ${response.statusText}`);
    }
    const result = await response.json();
    return result; // Return the entire result, not result.data
  } catch (error) {
    console.error(error);
    throw error; // Re-throw the error to be caught in the component
  }
};

export const subscribeToNewsletter = async (email) => {
  try {
    const response = await fetch(`${API_URL}/newsletter`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || "Something went wrong.");
    }

    return {
      success: true,
      message: "Successfully subscribed to the newsletter!",
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || "Network error. Please try again later.",
    };
  }
};

export const loginAdmin = async (email, password) => {
  try {
    const response = await fetch(`${API_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Login failed. Please try again.");
    }

    return data; // Return response data
  } catch (error) {
    throw new Error(
      error.message || "An error occurred. Please try again later."
    );
  }
};

export const fetchAdminPosts = async () => {
  try {
    const response = await fetch(`${API_URL}/posts/`);
    const result = await response.json();
    return result.data.posts;
  } catch (error) {
    console.error("Error fetching posts:", error);
    return [];
  }
};

export const fetchAllPosts = async (filter) => {
  let query = "";
  if (filter) {
    query = `?category=${filter}`;
  }
  try {
    console.log("⏳ Fetching all posts...");
    const response = await fetch(`${API_URL}/posts/all${query}`);

    if (!response.ok) {
      throw new Error(`HTTP Error! Status: ${response.status}`);
    }

    const result = await response.json();
    console.log("🟢 API Response:", result);
    return result.data.posts || [];
  } catch (error) {
    console.error("❌ Error fetching posts:", error);
    throw new Error(`${error.message || "there was an error here"}`);
  }
};

export const fetchPostById = async (id) =>
  await fetchOrThrowError(`posts/all/${id}`, "sorry couldnt get a post");

export const fetchPostBySlug = async (slug) => {
  const response = await fetchOrThrowError(
    `posts/all/slug/${slug}`,
    "Couldn't get post"
  );
  return response; // Directly return the response
};

export const getAllPostsCategories = async () =>
  await fetchOrThrowError(
    "posts/categories",
    "Sorry, there was an error fetching categories"
  );
export const getAllEmployees = async () =>
  await fetchOrThrowError(
    "employees",
    "Sorry there was an error when fetching employees"
  ).catch((error) => console.error("Error fetching employees:", error));

export const getAllTechTv = async () =>
  await fetchOrThrowError("techtv", "Sorry we couldnt get the tech tv data");

export const getAllEvents = async () =>
  fetchOrThrowError("events", "Sorry we couldnt get the event data");

export const convertToDate = (time) => {
  let convert = Math.floor(
    Math.abs(new Date() - new Date(time?.createdAt)) / (1000 * 60 * 60)
  );
  if (convert > 24) {
    convert = Math.floor(convert / 24);
    return `${convert} ${convert > 1 ? "days ago" : "day ago"}`;
  } else return `${convert}hrs ago`;
};

export const fetchEvents = async () => {
  const events = await fetchOrThrowError(
    "events",
    "Sorry we couldn't fetch the events at this time"
  );
  return events;
};
export function getFirstNWords(text, begin = 0, n = 100) {
  if (!text || typeof text !== "string") return "";

  const words = text.trim().split(/\s+/);
  return words.slice(begin, n).join(" ");
}
////POST API
const postOrThrowError = async (path) => {
  try {
    const result = await fetch(`${API_URL}/${path}`);
  } catch (error) {}
};
export const registerForEvent = async (id, body) => {
  try {
    const result = await fetch(`${API_URL}/events/${id}/attendees`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!result.ok) {
      const errorData = await result.json();
      throw new Error(errorData.message || "Failed to register");
    }

    return await result.json();
  } catch (error) {
    console.error("Registration error:", error);
    throw error; // Re-throw to handle in the calling function
  }
};
